// extracted by mini-css-extract-plugin
module.exports = {"searchIconWrapper":"SearchIcon_searchIconWrapper__Acg7i","searchIcon":"SearchIcon_searchIcon__sk8si"};